<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-8 offset-md-2">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Motores Unidades</h4>        
                    <hr>
                    <p> Administracion de Motores de las Unidades </p>                    
                </div>
            </div>            

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-high-traffic" data-toggle="tab" href="#nav-high" role="tab" aria-controls="nav-home" aria-selected="true"><font-awesome-icon icon="plus" /> Alta Motores</a>
                    <a class="nav-item nav-link" id="nav-edit-traffic" data-toggle="tab" href="#nav-edit" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="edit" /> Edición Motores</a>
                    <a class="nav-item nav-link" id="nav-low-traffic" data-toggle="tab" href="#nav-low" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="arrow-down" /> Baja Motores</a>
                </div>
            </nav>

            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-high" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Registro de Motores</h6>
                    <hr>                    
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-4" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                            <label for="nombre_embarcacion">Unidad <span class="required-text">*</span></label>  
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div v-else class="alert alert-success col-12 col-md-4 offset-md-4" align="center">
                            {{ cDtsUser.name_port }}
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="name_uuss">Marca UUSS <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="name_uuss" placeholder="YAMAHA"  autocomplete="off" v-model="engine_new.trademark">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="type_uuss">Modelo UUSS <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="name_uuss" placeholder="M-9876"  autocomplete="off" v-model="engine_new.model">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="operability_uuss">HP <span class="required-text">*</span></label>
                            <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="engine_new.hp">
                                <option v-for="hp in hp_engines" :value="hp.id" :key="hp.id">{{hp.detail}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="code_uuss">RPM <span class="required-text">*</span></label>
                            <input type="number" class="form-control" id="code_uuss" placeholder="150"  autocomplete="off" v-model="engine_new.rpm">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="trb_uuss">Serie <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="trb_uuss" placeholder="SERIE"  autocomplete="off" v-model="engine_new.serie">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="operability_uuss">Operabilidad <span class="required-text">*</span></label>
                            <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="engine_new.state_engine">
                                <option v-for="op in operabilitys" :value="op.id" :key="op.id">{{op.detail}}</option>
                            </select>
                        </div>
                    </div>
                    
                    <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mRegisterInitEngine">
                            <font-awesome-icon icon="save" size="3x" />
                    </button>

                </div>
                <!-- end first (high uuss) tab -->
                
                <div class="tab-pane fade"  id="nav-edit" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Busqueda y Edicion de Motores</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="engine_edit.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ engine_edit.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseEdit">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Marca</b></td>
                                    <td><b>modelo</b></td>
                                    <td><b>HP</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control" name="name_ship_edit" v-model="engine_edit.trademark"></td>
                                    <td>
                                        <input type="text" class="form-control" name="name_ship_edit" v-model="engine_edit.model">
                                    </td>
                                    <td>
                                        <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="engine_edit.hp">
                                            <option v-for="hp in hp_engines" :value="hp.id" :key="hp.id" :selected="hp.id === engine_edit.hp ? true : false">{{hp.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>RPM</b></td>
                                    <td><b>SERIE</b></td> 
                                    <td><b>OPERABILIDAD</b></td>
                                </tr>
                                <tr>
                                    <td><input type="numeric" class="form-control" name="code_ship_edit" v-model="engine_edit.rpm"></td>
                                    <td><input type="numeric" class="form-control" name="trb_ship_edit" v-model="engine_edit.serie"></td> 
                                    <td>
                                        <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="engine_edit.state_engine">
                                            <option v-for="state_e in operabilitys" :value="state_e.id" :key="state_e.id" :selected="state_e.id === engine_edit.state_engine ? true : false">{{state_e.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mUpdateEngine"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchEngine(1)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_engine_edit.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Marca / Serie</th>
                                        <th>HP</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(leu, index) in list_engine_edit" :key="leu.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span v-if="leu.trademark.length > 0">{{ leu.trademark }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                            / 
                                            <span v-if="leu.serie.length > 0">{{ leu.serie }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                        </td>
                                        <td>{{ leu.description_hp }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectEngineEdit(leu)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
                    
                </div>
                <!-- end second (edit) tab -->

                <div class="tab-pane fade"  id="nav-low" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>BAJA UUSS</h6>
                    <hr>
                    <transition name="fade" mode="out-in">

                    <div v-if="engine_low.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ engine_low.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseLow">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Marca</b></td>
                                    <td><b>Modelo</b></td>
                                    <td><b>HP</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control-plaintext" name="name_ship_edit" v-model="engine_low.trademark"></td>
                                    <td>
                                        <input type="text" class="form-control-plaintext" name="name_ship_edit" v-model="engine_low.model">
                                    </td>
                                    <td>
                                        <select name="state_engine" class="form-control" id="state_engine" v-model="engine_low.hp" disabled>
                                            <option v-for="soe in hp_engines" :value="soe.id" :key="soe.id" :selected="soe.id === engine_low.hp ? true : false">{{soe.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>RPM</b></td>
                                    <td><b>SERIE</b></td> 
                                    <td><b>Operabilidad</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control-plaintext" name="code_ship_edit" v-model="engine_low.rpm"></td>
                                    <td><input type="numeric" class="form-control-plaintext" name="trb_ship_edit" v-model="engine_low.serie"></td> 
                                    <td>
                                        <select name="state_engine" class="form-control" id="state_engine" v-model="engine_low.state_engine" disabled>
                                            <option v-for="soe in operabilitys" :value="soe.id" :key="soe.id" :selected="soe.id === engine_low.state_engine ? true : false">{{soe.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Detalle Baja</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><textarea type="text" class="form-control" name="description_engine_low" v-model="engine_low.description_low"> </textarea> </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-danger col-12 col-md-2 offset-md-4" @click="mLowEngine"><font-awesome-icon icon="arrow-circle-down" size="2x" /></button>
                        <button class="btn btn-warning col-12 col-md-2" @click="mCloseLow"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchEngine(2)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_engine_low.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Marca / Serie</th>
                                        <th>HP</th>
                                        <th><font-awesome-icon icon="times-circle" size="2x"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lul, index) in list_engine_low" :key="lul.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span v-if="lul.trademark.length > 0">{{ lul.trademark }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                            / 
                                            <span v-if="lul.serie.length > 0">{{ lul.serie }}</span>
                                            <span v-else>SIN REGISTRO</span>
                                        </td>
                                        <td>{{ lul.description_hp }}</td>
                                        <td>
                                            <button class="btn btn-outline-danger" @click="mSelectShipLow(lul)">
                                                <font-awesome-icon icon="times-circle"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>   
                </div>
                <!-- end tirdth tab (low) -->

            </div>

        </div>
        <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'UUSS',
    data(){
        return{
            list_engine_edit:[],
            list_engine_low:[],
            engine_edit:{
                id:0,
                captain:null,
                trademark:null,
                model:null,
                hp:0,
                rpm:0,
                serie:null,
                state_engine:0
            },
            engine_low:{
                id:0,
                captain:null,
                trademark:null,
                model:null,
                hp:0,
                rpm:null,
                serie:null,
                state_engine:0,
                description_low:null
            },
            id_modal_progress:'load_engine',
            title_modal:'Registrando',
            send_dispatch:true,
            ports:[],
            engines:[],
            operabilitys:[],
            captain_register:{
                id:0,
                name_port:null
            },
            engine_new:{
                id_captain:0,
                trademark:null,
                model:null,
                hp:0,
                rpm:null,
                serie:null,
                state_engine:0
            },
            hp_engines:[]
        }
    },
    mounted(){
        this.mInit();
    },
    methods:{
        mCloseEdit(){
            this.engine_edit.id=0;
            this.engine_edit.captain=null;
            this.engine_edit.trademark=null;
            this.engine_edit.model=null;
            this.engine_edit.hp=0;
            this.engine_edit.rpm=null;
            this.engine_edit.serie=null;
            this.engine_edit.state_engine=null;
        },
        mCloseLow(){
            this.engine_low.id=0;
            this.engine_low.captain=null;
            this.engine_low.trademark=null;
            this.engine_low.model=null;
            this.engine_low.hp=0;
            this.engine_low.rpm=null;
            this.engine_low.serie=null;
            this.engine_low.state_engine=null;
            this.engine_low.description_low=null;
        },
        mSelectEngineEdit(na){
            // console.log('la nave ha sido seleccionada');
            // console.log(na);
            this.engine_edit.id=na.id;
            this.engine_edit.description_hp=na.description_hp;
            this.engine_edit.captain=na.captain;
            this.engine_edit.trademark=na.trademark;
            this.engine_edit.model=na.model;
            this.engine_edit.hp=na.hp;
            this.engine_edit.rpm=na.rpm;
            this.engine_edit.serie=na.serie;
            this.engine_edit.state_engine=na.state_engine;
        },
        mSelectShipLow(na){
            // console.log('la nave ha sido seleccionada');
            // console.log(na);
            this.engine_low.id=na.id;
            this.engine_low.description_hp=na.description_hp;
            this.engine_low.captain=na.captain;
            this.engine_low.trademark=na.trademark;
            this.engine_low.model=na.model;
            this.engine_low.hp=na.hp;
            this.engine_low.rpm=na.rpm;
            this.engine_low.serie=na.serie;
            this.engine_low.state_engine=na.state_engine;
            this.engine_low.description_low=na.description_low;
        },
        async mSearchEngine(tv = 1){
            this.list_engine_edit=[];
            this.list_engine_low=[];
            if(this.cDtsUser.roleAssign !== 'OPERADOR UNIDAD'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una Unidad', 'Unidad');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }
            let list_engine = await axios.get(`getListEngine/${this.captain_register.id}?api_token=${Vue.auth.getToken()}`);
            // console.log(list_engine);
            try {
                console.log(tv);
                if(list_engine.data.length>0){
                    if(tv === 1){
                        this.list_engine_edit=list_engine.data;
                    }else{
                        this.list_engine_low=list_engine.data;
                    }
                }else{
                    toastr.info(`La Unidad ${this.captain_register.name_port} no registra Motores`, 'Mensaje');
                }                 
            } catch (error) {
                console.log(error);
                toastr.error(`Ha ocurrido un error al Recuperar los datos`, 'Error UUSS-02');
            }               
        },
        async mInit(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let hp=await axios.get(`globals/hp?api_token=${Vue.auth.getToken()}`);
            let states=await axios.get(`globals/operability?api_token=${Vue.auth.getToken()}`);
            this.hp_engines=hp.data;
            this.ports=cp.data;
            this.operabilitys=states.data;
        },
        async mRegisterInitEngine(){
            // validamos y registramos la capitania
            if(this.mValidateRegister()){
                let message = {
                    title: 'Registro de Motor',
                    body: `¿Desea Registrar el Motor para la Unidad ${this.captain_register.name_port}?`
                }
                this.engine_new.id_captain=this.captain_register.id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            console.log(`estamos enviando al servidor`);
                            let reg_engine=await axios.post(`engineInsert?api_token=${Vue.auth.getToken()}`, qs.stringify(this.engine_new));
                            console.log(reg_engine);
                            setTimeout(()=>{                                
                                if(reg_engine.data.status){
                                    toastr.success(reg_engine.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.engine_new.id_captain=0;
                                    this.engine_new.trademark=null;
                                    this.engine_new.model=null;
                                    this.engine_new.hp=0;
                                    this.engine_new.rpm=0;
                                    this.engine_new.serie=null;
                                    this.engine_new.state_engine=0;
                                }else{
                                    toastr.success(reg_uuss.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el registro', 'Error UUSS-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateRegister(){
            if(this.cDtsUser.roleAssign !== 'OPERADOR UNIDAD'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una Unidad', 'Unidad');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }

            
            // if(this.uuss_new.name===null || this.uuss_new.name===''){
            //     toastr.warning('Indique el nombre de la nave', 'Atencion');
            //     return false;
            // }
            if(this.engine_new.hp===0){
                toastr.warning('Indique los HP del Motor', 'HP');
                return false;
            }
            if(this.engine_new.state_engine===0){
                toastr.warning('Indique el estado de Operabilidad', 'Estado Operabilidad');
                return false;
            }
            return true;
        },
        async mUpdateEngine(){
            // validamos y registramos la capitania
            if(this.mValidateUpdate()){
                let message = {
                    title: 'Actualizacion Motor',
                    body: `¿Desea Actualizar el Motor para la Unidad ${this.engine_edit.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let update_engine=await axios.post(`engineUpdate?api_token=${Vue.auth.getToken()}`, qs.stringify(this.engine_edit));
                            
                            this.mSearchEngine(1);

                            setTimeout(()=>{                                
                                if(update_engine.data.status){
                                    toastr.success(update_engine.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.mCloseEdit();
                                }else{
                                    toastr.success(update_engine.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la actualizacion', 'Error Engine-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateUpdate(){
            // if(this.engine_edit.trademark===0){
            //     toastr.warning('Seleccione un tipo de nave', 'Tipo Nave');
            //     return false;
            // }
            if(this.engine_edit.hp===0){
                toastr.warning('Debe seleccionar un HP del Motor', 'HP');
                return false;
            }
            if(this.engine_edit.state_engine===0){
                toastr.warning('Seleccione la operabilidad del Motor', 'Motor');
                return false;
            }
            
            return true;
        },
        async mLowEngine(){
            // validamos y registramos la capitania
            if(this.mValidateLow()){
                let message = {
                    title: 'Baja Motor',
                    body: `¿Desea dar de Baja el Motor para la Unidad ${this.engine_low.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let low_engine=await axios.post(`engineLow?api_token=${Vue.auth.getToken()}`, qs.stringify(this.engine_low));
                            
                            this.mSearchEngine(2);
                            this.mSearchEngine(1);

                            setTimeout(()=>{                                
                                if(low_engine.data.status){
                                    toastr.success(low_engine.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.mCloseLow();
                                }else{
                                    toastr.success(low_engine.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la actualizacion', 'Error UUSS-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateLow(){
            if(this.engine_low.description_low===null || this.engine_low.description_low === '' ){
                toastr.warning('Indique una breve descripcion de las causales de la baja', 'Atencion');
                return false;
            }
            return true;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-loading':modalLoading
    }    
}
</script>

<style>
.required-text{
    color:red; 
    font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/uuss/engine.vue